module.exports = __webpack_public_path__ + "static/media/builderContentOne.61c9a4ec.svg";